import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StageComponent, CoreShapeComponent } from 'ng2-konva';

import { AppCommonsModule } from '../../../commons/app-commons.module';

import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { SectionInfoComponent } from './section-info.component';


/**
 * ページパターン設定画面 セクション情報 モジュール設定クラス
 *
 * @export SectionInfoComponent
 * @class SectionInfoComponent
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    StageComponent,
    CoreShapeComponent,
  ],
  declarations: [
    SectionInfoComponent,
  ],
  providers: [
  ],
  exports: [
    SectionInfoComponent,
  ]
})
export class SectionInfoModule {
}
